import { h } from "preact";
import { useDisplayLoggedIn } from "services/user";

export const AccountLink = () => {
    const loggedIn = useDisplayLoggedIn();
    return loggedIn ? <div className={"text"}>{`User name`}</div> : null;
};
